import { render, staticRenderFns } from "./MapLocationStatic.vue?vue&type=template&id=28dd22e0&scoped=true&"
import script from "./MapLocationStatic.vue?vue&type=script&lang=js&"
export * from "./MapLocationStatic.vue?vue&type=script&lang=js&"
import style0 from "./MapLocationStatic.vue?vue&type=style&index=0&id=28dd22e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd22e0",
  null
  
)

export default component.exports